// extracted by mini-css-extract-plugin
export default {"button":"LanguageChanger_button__JaK2w","buttonActive":"LanguageChanger_buttonActive__1Q+BX"};